import sweetalert2 from 'sweetalert2';

export function ajaxErrorSwal(jqXhr: JQuery.jqXHR<any>, title = 'Oops, something went wrong') {
  sweetalert2.fire({ title, type: 'error', text: ajaxErrorString(jqXhr) });
}

export function ajaxSuccessSwal(text: string, title = 'Success') {
  sweetalert2.fire({ title, text, type: 'success' });
}

export function ajaxErrorString(jqXhr: JQuery.jqXHR<any>) {
  if (jqXhr.status === 0) {
    return 'The request was blocked by the browser. Are you using an ad blocker?';
  }
  if (jqXhr.status === 500) {
    return 'Unknown server error';
  }
  if (jqXhr.responseJSON && jqXhr.responseJSON.errors) {
    return jqXhr.responseJSON.errors.map((e) => e.title).join(', ');
  }
  if (jqXhr.status === 401) {
    return jqXhr.responseJSON.message;
  }
  return 'Unknown server error';
}

type ResourceWithFullMessageErrors = { errors: Record<string, { fullMessage: string }> };

const extractFullMessages = (resource: ResourceWithFullMessageErrors) => {
  return Object.keys(resource.errors).map((key) => {
    return resource.errors[key].fullMessage;
  });
};

/**
 * Goes through the errors object on a Spraypaint resource and extract all of
 * their `fullMessage` properties into a single string.
 *
 * @param resourceOrResources The Spraypaint resource or array of resources we're pulling errors from.
 * @returns A string of all the errors joined by a comma.
 */
export function graphitiErrorString(
  resourceOrResources: ResourceWithFullMessageErrors | ResourceWithFullMessageErrors[],
) {
  const errors: string[] = [];

  if (Array.isArray(resourceOrResources)) {
    const resourceArray = resourceOrResources;
    // combine all errors into one object
    resourceArray.forEach((resource) => {
      errors.push(...extractFullMessages(resource));
    });
  } else {
    const resource = resourceOrResources;
    errors.push(...extractFullMessages(resource));
  }

  return errors.join(', ');
}

type ResourceWithMessageErrors = { errors: Record<string, { message: string }> };

const extractMessages = (resource: ResourceWithMessageErrors) => {
  return Object.keys(resource.errors).map((key) => {
    return resource.errors[key].message;
  });
};

/**
 * Goes through the errors object on a Spraypaint resource and extract all of
 * their `message` properties into a single string.
 *
 * @param resourceOrResources The Spraypaint resource or array of resources we're pulling errors from.
 * @returns A string of all the errors joined by a comma.
 */
export function graphitiSimpleErrorString(
  resourceOrResources: ResourceWithMessageErrors | ResourceWithMessageErrors[],
) {
  const errors: string[] = [];

  if (Array.isArray(resourceOrResources)) {
    const resourceArray = resourceOrResources;
    // combine all errors into one object
    resourceArray.forEach((resource) => {
      errors.push(...extractMessages(resource));
    });
  } else {
    const resource = resourceOrResources;
    errors.push(...extractMessages(resource));
  }

  return errors.join(', ');
}
